import { GetSectionsResponse, SectionsService } from "@/client";
import { HttpError } from "@/types/error";
import {
  UseQueryOptions,
  keepPreviousData,
  useQuery,
} from "@tanstack/react-query";

const sectionsQueryKey = (
  congressId: string,
  pageSize = 10,
  pageIndex = 0,
  search?: string,
  sortBy?: "rating" | "ratingCount" | "from",
  sortOrder?: "asc" | "desc",
) => {
  return [
    "sections",
    congressId,
    pageSize,
    pageIndex,
    search,
    sortBy,
    sortOrder,
  ] as const;
};

function useGetSections(
  {
    congressId,
    pageSize = 10,
    pageIndex = 0,
    search,
    sortBy,
    sortOrder,
  }: {
    congressId: string;
    pageSize?: number;
    pageIndex?: number;
    search?: string;
    sortBy?: "rating" | "ratingCount" | "from";
    sortOrder?: "asc" | "desc";
  },
  queryOptions?: Partial<UseQueryOptions<GetSectionsResponse, HttpError>>,
) {
  const offset = pageIndex * pageSize;

  return useQuery({
    queryKey: sectionsQueryKey(
      congressId,
      pageSize,
      pageIndex,
      search,
      sortBy,
      sortOrder,
    ),
    queryFn: () =>
      SectionsService.getSections({
        congressId,
        limit: pageSize,
        offset,
        search,
        sortBy,
        sortOrder,
      }),
    placeholderData: keepPreviousData,
    ...queryOptions,
  });
}

export { sectionsQueryKey, useGetSections };
